import { doRequest } from "utils/core";

const entryAPI = {
  getEntry: (params) => {
    const url = "api/entry/list";
    return doRequest("get", url, { params });
  },
  postEntrySubmit: (data) => {
    const url = "api/entry/submit";
    return doRequest("post", url, { data });
  },
  updateEntry: (data) => {
    const url = "api/entry/update";
    return doRequest("post", url, { data });
  },
};

export default entryAPI;
